import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import {PopoverWarningBadge} from 'ui-library/WarningBadge';

export default function HiddenAnnotationsWarningBadge({iconOnly = false}: {iconOnly?: boolean}): JSX.Element {
  return (
    <BufferOptionsItem>
      <PopoverWarningBadge
        content={iconOnly ? null : 'Annotations'}
        className={css(styles.badge)}
        popoverProps={{
          renderContent: () => (
            <span>
              The 100 largest annotations in the viewing window are shown. Use the{' '}
              <strong>zoom feature</strong> to see a particular region in more detail.
            </span>
          ),
          title: 'Annotations',
          placement: FloatingPlacement.BOTTOM,
        }}
      />
    </BufferOptionsItem>
  );
}
const styles = StyleSheet.create({
  badge: {
    whiteSpace: 'nowrap',
  },
});
